<template>
  <div class="breadcrumb-nav">
    <span :class="{'show-cursor': path.length}" @click="back" v-if="path.length" style="font-size:14px">Home</span> &nbsp;<i class="fa fa-chevron-right" v-if="path.length"></i> <span v-for="(tray, index) in path" :key="tray.id" @click="browse(tray, index)" :title="tray.name" :class="{'show-cursor': path.length !== (index + 1)}"> {{ str_text(toTitleCase(tray.name)) }} &nbsp;<i class="fa fa-chevron-right" v-if="path.length !== (index + 1)"></i></span>
    <!-- <template v-if="path.length < 4">
      <span :class="{'show-cursor': path.length}" @click="back" v-if="path.length" style="font-size:14px">Home</span> &nbsp;<i class="fa fa-chevron-right" v-if="path.length"></i> <span v-for="(tray, index) in path" :key="tray.id" @click="browse(tray, index)" :title="tray.name" :class="{'show-cursor': path.length !== (index + 1)}"> {{ str_text(toTitleCase(tray.name)) }} &nbsp;<i class="fa fa-chevron-right" v-if="path.length !== (index + 1)"></i></span>
    </template>
    <template v-else>

    </template> -->
  </div>
</template>
<style>
.breadcrumb-nav span:first-child {
  margin-left: 0 !important;
}
</style>

<script>
import { mapMutations } from 'vuex'

export default {
  props: ['path'],
  methods: {
    ...mapMutations([
      'SET_DB',
      'SET_CAN_CREATE',
      'SET_CREATE_RIGHT',
      'SET_GROUP_CREATE_MODE'
    ]),
    str_text (str) {
      if (str.length > 16) {
        return str.substr(0, 16) + '...'
      }

      return str
    },
    toTitleCase (text) {
      let txt = []
      text.split(' ').map(str => {
        txt.push(str.charAt(0).toUpperCase() + str.substring(1, str.length).toLowerCase())
      })

      return txt.join(' ')
    },
    browse (tray, index) {
      // console.log(tray)
      if (this.path.length === (index + 1)) {
        return
      }

      sessionStorage.setItem('group_create', tray.can_create)
      sessionStorage.setItem('group', tray.db)
      // sessionStorage.setItem('is_group', dir.is_group)

      this.SET_CREATE_RIGHT(sessionStorage.getItem('group_create'))
      this.SET_DB(sessionStorage.getItem('group'))
      this.SET_CAN_CREATE(sessionStorage.getItem('create'))

      if (String(tray.id) === String(sessionStorage.getItem('gi')) && tray.db === 'group') {
        sessionStorage.setItem('create_mode', true)
        this.SET_GROUP_CREATE_MODE(sessionStorage.getItem('create_mode'))
      }

      if (tray.id === undefined) {
        sessionStorage.setItem('create', false)
      } else {
        sessionStorage.setItem('create', true)
      }

      if (tray.db == 'public' && tray.id == undefined) {
        this.$emit('browse_dir', [tray.name, this.$store.getters.PUBLIC_FOLDER_ID, tray.db, tray.file_type, tray.is_public, tray.can_create, tray.can_download, tray.can_upload])
      }

      if (tray.db == 'group' && tray.id == undefined) {
        this.$emit('browse_dir', [tray.name, sessionStorage.getItem('gi'), tray.db, tray.file_type, tray.is_public, tray.can_create, tray.can_download, tray.can_upload])
      }

      if (tray.db == 'group' && tray.id != undefined) {
        this.$emit('browse_dir', [tray.name, tray.id, tray.db, tray.file_type, tray.is_public, tray.can_create, tray.can_download, tray.can_upload])
      }

      if (tray.db == 'public' && tray.id != undefined) {
        this.$emit('browse_dir', [tray.name, tray.id, tray.db, tray.file_type, tray.is_public, tray.can_create, tray.can_download, tray.can_upload])
      }

      if (tray.db == 'filesystem' && tray.id != undefined) {
        this.$emit('browse_dir', [tray.name, tray.id, tray.db, tray.file_type, tray.is_public, tray.can_create, tray.can_download, tray.can_upload])
      }

      if (tray.db == 'sharedwithme' && tray.id == undefined) {
        this.$emit('browse_dir', [tray.name, tray.id, tray.db, tray.file_type, tray.is_public, tray.can_create, tray.can_download, tray.can_upload, tray.parent])
      }

      if (tray.db == 'sharedwithme' && tray.id != undefined) {
        this.$emit('browse_dir', [tray.name, tray.id, tray.db, tray.file_type, tray.is_public, tray.can_create, tray.can_download, tray.can_upload, tray.parent])
      }
    },
    back () {
      this.$parent.back()
    }
  },
  mounted () {
    // console.log(this.path)
  }
}
</script>
